// +----------------------------------------------------------------------
// | axios二次封装(统一请求拦截、统一响应拦截)
// +----------------------------------------------------------------------
import axios from 'axios';
import base from '@/config/config';


// +----------------------------------------------------------------------
// | Desc:为空验证
// +----------------------------------------------------------------------
function isblank(value) {
    const emptyValues = [null, "null", "NULL", "undefined", undefined, 'UNDEFINED', ''];
    if (emptyValues.includes(value)) {
        return true;
    }
    if (Array.isArray(value) && value.length === 0) {
        return true;
    }
    if (typeof value === 'object' && value !== null && Object.keys(value).length === 0 && value.constructor === Object) {
        return true;
    }
    return false;
}

// +----------------------------------------------------------------------
// | 创建axios实例
// +----------------------------------------------------------------------
const service = axios.create({
    baseURL: base.api,
    timeout: 30000,
    // ... 其他axios配置  
});


// +----------------------------------------------------------------------
// | 请求拦截器
// +----------------------------------------------------------------------
service.interceptors.request.use(
    config => {
        //设置请求头-请求类型
        config.headers['Content-Type'] = 'application/json;charset=utf-8';

        //设置请求头-请求token
        var token = localStorage.getItem('token');
        if (isblank(token)) {
            var token = sessionStorage.getItem('token')
        };
        config.headers['token'] = token;

        return config;
    },
    error => {
        // 请求错误处理  
        console.error(1, error);
        return Promise.reject(error);
    }
);



// +----------------------------------------------------------------------
// | 响应拦截器
// +----------------------------------------------------------------------
service.interceptors.response.use(
    // 响应成功处理  
    response => {
        //登录过期拦截
        if (response.data.code == "10001") {
            localStorage.setItem("token", null);
            sessionStorage.setItem("token", null);
            localStorage.setItem("user", null);
            location.href = "/login";
        };
        return response.data;
    },

    // 响应错误处理
    error => {
        let _this = this;
        if (error.response) {
            console.error('2', error);
        } else {
            // 网络错误等，可以根据业务需求进行相应处理  
            console.error('3', error);
        };
        return Promise.reject(error);
    }
);
export default service;